<template>
    <Toast />
	<div class="grid p-fluid">
		<div class="col-12 md:col-6">
			<div class="card">
				<h5 style="margin-bottom: 1rem;">Configuración del sistema</h5>
				<DataView :value="this.settingsHeaders">
					<template #list="slotProps">
						<div style="width: 100%; border-radius: 12px; background-color: #f9fafb; padding: 1rem; margin-bottom: 1.5rem; box-shadow: 0 1px 3px rgba(0,0,0,0.1);"> 
							<div class="flex" >
								<h5 style="margin-bottom: 1rem;">{{ slotProps.data.name }}</h5>
								<InputSwitch v-if="slotProps.data.optional" v-model="slotProps.data.value" class="ml-auto"/>
							</div>
							<DataView v-if="slotProps.data.value" :value="confOptions.filter(item => item.parent === slotProps.data.name)" style="padding: 0rem 2rem 0rem 1.5rem; margin-bottom: 2rem;" >
								<template #list="option">
									<div style="width: 100%; display: flex; background-color: #f9fafb;">
										<h6 style="margin: 0rem; padding-top: 1rem;" :style="{opacity: !slotProps.data.value ? 0.5 : 1}">{{ option.data.name }}</h6>
										<div style="min-width: 40px;" class="ml-auto">
											<InputSwitch v-model="option.data.value" :disabled="!slotProps.data.value" style="margin: 0.5rem 0rem;"/>
										</div>
									</div>
								</template>
							</DataView>
						</div>
					</template>
				</DataView>

				<Button label="Guardar" :loading="isSaveDefaultsButtonLoading" style="width: auto; margin: 1rem 0px 0px auto !important;" class="p-button-raised p-button-success mr-2 mb-2"  @click="saveDefaults()"/>
			</div>

			<div class="card">
				<h5 style="margin-bottom: 5px;">Impresora de Ticket</h5>
				<small style="font-style: italic; color: gray;">Compatible con impresoras EPSON</small>
				<div class="grid formgrid">
					<div class="col-12 mb-2 lg:col-12 lg:mb-0">
						<label v-if="this.devices !== null && this.devices.length === 0" style="margin-top: 20px;">
							No hay dispositivos registrados
						</label>
						<div class="grid formgrid" v-for="device in this.devices" :key="device.id">
							<div class="col-12 mb-2 lg:col-8 lg:mb-0">
								<div style="width: 100%;">
									<label style="margin: 1.5rem 0rem 0.2rem 0rem;"><b>{{ device.name }}</b></label><br>
									<label :style="{color: ((device.connected) ? 'green' : 'red')}">{{ device.connected ? "Conectado" : "Desconectado" }}</label>
								</div>
							</div>
							<div class="col-12 mb-2 lg:col-4 lg:mb-0">
								<div style="display: flex; text-align: right; padding: 1.5rem 0px;">
									<div style="margin: 0px 0px 0px auto; width: 1px;"></div>
									<RadioButton name="device" :value="device" v-model="this.selectedDevice" style="padding: 10px 0px; margin-left: 20px;" @click="onSelectDevice(device.id)"/>
								</div>
							</div>
							<div style="margin-top: 5px; width: 100%; height: 1px; background-color: lightgray"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-12 md:col-6">
			<div class="card">
				<h5 style="margin-bottom: 5px;">Actualización de contraseña</h5>
				<form id="password">
					<div class="grid formgrid">
						<div class="col-12 mb-2 lg:col-12 lg:mb-0">
							<h6 style="margin: 1.5rem 0rem 0.5rem 0rem;">Actual contraseña</h6>
							<Password autocomplete placeholder="Contraseña" v-model="this.passwords.old" :feedback="false" :toggleMask="true" :class="{'w-full': true, 'mb-3': true}" inputClass="w-full" inputStyle="padding:1rem"></Password>
						</div>
						<div class="col-12 mb-2 lg:col-12 lg:mb-0">
							<h6 style="margin: 1.5rem 0rem 0.5rem 0rem;">Nueva contraseña</h6>
							<Password autocomplete placeholder="Contraseña (mínimo 8 caracteres)" v-model="this.passwords.new" :feedback="false" :toggleMask="true" :class="{'w-full': true, 'mb-3': true}" inputClass="w-full" inputStyle="padding:1rem"></Password>
						</div>
						<Button label="Guardar" :loading="isUpdatePasswordButtonLoading" style="width: auto; margin: 1rem 0rem 0rem auto !important;" class="p-button-raised p-button-success mr-2 mb-2"  @click="updatePassword()"/>
					</div>
				</form>
				
			</div>

			<div v-if="isAdmin && isCuentasEnabled" class="card">
				<h5 style="margin-bottom: 5px;">Reporte de cierre de caja</h5>
				<small style="font-style: italic; color: gray;">Destinatarios que recibirán el reporte automático tras cada cierre. Separe los correos con coma.</small>
				<div class="grid formgrid mt-3">
					<div class="col-12 mb-2 lg:col-12 lg:mb-0">
						<Textarea v-model="cashClosingRecipients" rows="3" class="w-full" placeholder="contador@empresa.com, gerente@empresa.com" />
					</div>
					<Button label="Guardar" :loading="isSaveRecipientsLoading" style="width: auto; margin: 1rem 0rem 0rem auto !important;" class="p-button-raised p-button-success mr-2 mb-2" @click="saveCashClosingRecipients()" />
				</div>
			</div>
		</div>
	</div>

	<!-- Login after password update -->
	<Dialog header="Alerta" v-model:visible="displayLoginDialog" :style="{width: '350px'}" :modal="true" :closeOnEscape="false" :closable="false" >
		<div class="flex align-items-center justify-content-center">
			<i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
			<span>Debido a la actualización de contraseña, se requiere que inicie sesión nuevamente</span>
		</div>
		<template #footer>
			<Button label="Iniciar Sesión" icon="pi pi-check" @click="onLoginAgain" class="p-button-text" autofocus />
		</template>
	</Dialog>
</template>
<script>
	import httpRequest from '../../service/httpRequest';
	import Device from '../../models/device';
	import Business from '../../models/business';

	export default {
		data() {
			return {
				devices: [],
				selectedDevice: null,
				business: new Business(),
				user: null,
				passwords: {},
				confOptions: [],
				settingsHeaders: [],

				// Loading
				isSaveDefaultsButtonLoading: false,
				isUpdatePasswordButtonLoading: false,
				isSaveRecipientsLoading: false,

				// Cash closing
				cashClosingRecipients: '',

				// Show
				displayLoginDialog: false,
			}
		},
		watch: {
			settingsHeaders: {
				deep: true,
				handler(newHeaders) {
					// Cuando cambia un header, verificar si se desactivó
					newHeaders.forEach(header => {
						// Solo procesar headers opcionales
						if (header.optional && !header.value) {
							// Si el header está desactivado, desactivar todas sus opciones hijas
							this.confOptions.forEach(option => {
								if (option.parent === header.name) {
									option.value = false;
								}
							});
						}
					});
				}
			}
		},
		async beforeMount() {
			this.business = await this.$store.getters.business;
			this.user = await this.$store.getters.getUser;
			await this.parseDefaultsToConfigs();
			await this.loadCashClosingRecipients();
		},
		created() {
			this.getDevices();

		},
		methods: {
			async getDevices() {
				const response = await httpRequest.getDevices();
				if (response.status === 200) {
					this.devices = response.data.map(device => new Device(device))
					// find selected
					for (var i=0; i<this.devices.length; i++) {
						if (this.devices[i].selected) {
							this.selectedDevice = new Device(this.devices[i]);
						}
					}
				}
			},
			async onSelectDevice(id) {
				const response = await httpRequest.selectDevice(id);
				if (response.status === 200) {
					this.$toast.add({severity:'success', summary: 'Impresora seleccionada', detail: '', life: 3000});

					let device = new Device(response.data);
					this.selectedDevice = device;
					for (var i=0; i<this.devices.length; i++) {
						if (this.devices[i].id === device.id) {
							this.devices[i] = device;
						}
					}
				}
			},
			parseDefaultsToConfigs() {
				const configs = [];
				if (this.user.settings && this.user.settings.settings) {
					for (const [key, value] of Object.entries(this.user.settings.settings)) {
						const tmp = {... value};
						tmp.key = key
						configs.push(tmp)
					}
				}
				this.confOptions = configs;

				const headers = [];
				if (this.user.settings && this.user.settings.settings_headers) {
					for (const [key, value] of Object.entries(this.user.settings.settings_headers)) {
						const tmp = {... value};
						tmp.name = key;
						headers.push(tmp);
					}
				}
				this.settingsHeaders = headers;
			},
			parseConfigsToDefaults() {
				// Asegurarse de que settings existe
				if (!this.user.settings) {
					this.user.settings = {};
				}
				if (!this.user.settings.settings) {
					this.user.settings.settings = {};
				}
				if (!this.user.settings.settings_headers) {
					this.user.settings.settings_headers = {};
				}

				for (const value of Object.entries(this.confOptions)) {
					const tmp = {... value[1]};
					const key = tmp.key;
					delete tmp["key"];
					this.user.settings.settings[key] = tmp;
				}

				for (const value of Object.entries(this.settingsHeaders)) {
					const tmp = {... value[1]};
					const key = tmp.name;
					delete tmp["name"];
					this.user.settings.settings_headers[key] = tmp;
				}
			},
			async saveDefaults() {
				this.parseConfigsToDefaults(this.confOptions);
				this.isSaveDefaultsButtonLoading = true;
				const response = await httpRequest.saveUserSettings(this.user.settings);
				this.isSaveDefaultsButtonLoading = false;
				const title = (response.status === 200) ? "Éxito" : "Error";
				const message = (response.status === 200) ? "Su configuración ha sido guardada." : "Error guardando su configuración, por favor intente nuevamente."
				this.$toast.add({severity:(response.status === 200) ? 'success' : 'error', summary: title, detail: message, life: 3000});

				// Store changes in local memory and rebuild menu
				if (response.status === 200) {
					await this.$store.dispatch('Login', this.user);
					// Recargar la página para aplicar cambios en el menú
					window.location.reload();
				}
			},
			async updatePassword() {
				if (this.passwords.old === undefined || this.passwords.old === "") {
					this.$toast.add({severity: 'error', summary: "Error", detail: "Ingrese su contraseña actual", life: 3000});
				} else if (this.passwords.new === undefined || this.passwords.new === "") {
					this.$toast.add({severity: 'error', summary: "Error", detail: "Ingrese su nueva contraseña", life: 3000});
				} else if (this.passwords.new.length < 8) {
					this.$toast.add({severity: 'error', summary: "Error", detail: "Su nueva contraseña tiene que ser mayor o igual a 8 caracteres", life: 6000});
				} else {
					this.isUpdatePasswordButtonLoading = true;
					const response = await httpRequest.updatePassword(this.passwords.old, this.passwords.new);
					this.isUpdatePasswordButtonLoading = false;
					if (response.status === 200) {
						this.$toast.add({severity:'success', summary: 'Contraseña actualizada', detail: '', life: 3000});
						this.displayLoginDialog = true;
					} else {
						this.$toast.add({severity:'error', summary: 'Error', detail: 'Error actualizando contraseña, intente nuevamente.', life: 3000});
					}
				}
			},
			async onLoginAgain() {
				await this.$store.dispatch('Logout');
				this.$router.push('/login');
			},
			async loadCashClosingRecipients() {
				try {
					const response = await httpRequest.getCashClosingPreview();
					if (response && response.status === 200 && response.data) {
						this.cashClosingRecipients = response.data.recipients || '';
					}
				} catch (e) {
					console.error('Error cargando recipients de cierre de caja:', e);
				}
			},
			async saveCashClosingRecipients() {
				this.isSaveRecipientsLoading = true;
				try {
					const response = await httpRequest.saveCashClosingRecipients(this.cashClosingRecipients);
					if (response.status === 200 && response.data) {
						this.cashClosingRecipients = response.data.recipients || '';
						this.$toast.add({severity: 'success', summary: 'Destinatarios actualizados', life: 3000});
					} else {
						this.$toast.add({severity: 'error', summary: 'Error', detail: response.error || 'No se pudieron guardar los destinatarios', life: 4000});
					}
				} catch (e) {
					console.error(e);
					this.$toast.add({severity: 'error', summary: 'Error', detail: 'Fallo de red', life: 4000});
				} finally {
					this.isSaveRecipientsLoading = false;
				}
			},
		},
		computed: {
			isAdmin() {
				// Espejo del decorador backend: la configuración del negocio es admin-only.
				return this.$can('configuration');
			},
			isCuentasEnabled() {
				const header = this.settingsHeaders.find(h => h.name === 'Cuentas');
				return !!(header && header.value);
			}
		}
	}
</script>

<style scoped>
.pi-eye {
    transform:scale(1.6);
    margin-right: 1rem;
}

.pi-eye-slash {
    transform:scale(1.6);
    margin-right: 1rem;
}

.p-datatable-thead {
	display: none;
}

@media screen and (max-width: 760px) {
    .creds-container {
        width: 90%;
    }
}
</style>